import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { fuseAnimations } from 'admin/@fuse/animations';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MustMatch } from 'admin/utile/validators/MustMatch';
import { BaseForgotPass } from 'admin/baseLogin/BaseForgotPass';
import { DevAccountService } from 'admin/userTemplate/app-login/main/services/accountService';

@Component({
    selector: 'forgot-pass',
    template: require('./forgot-pass.component.html'),
    styles: [require('./forgot-pass.component.scss')],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations
})
export class DevForgotPassComponent extends BaseForgotPass implements OnInit
{
    newPasswordForm: FormGroup;

    constructor(
        private _formBuilder: FormBuilder,
        protected router: Router,
        protected route: ActivatedRoute,
        protected accountService: DevAccountService)
    {
        super(
            router,
            route,
            accountService);
    }

    ngOnInit(): void {
        this.newPasswordForm = this._formBuilder.group(
            {
                resetToken: ['', [Validators.required]],
                password: ['', Validators.required],
                confirmPassword: ['', Validators.required]
            },
            {
                validator: MustMatch('password', 'confirmPassword')
            }
        );
    }
}
